import React from 'react';
/**
 * This is a magic component, which accept implicity setted by <TransitionGroup/> props
 * and pass them through react tree.
 * @internal
 */

export const ChipGroupContext = /*#__PURE__*/React.createContext(null);